/**
 * FooterLinks - Navigation links for Privacy, Terms, FAQs, Contact
 */

import { Urls } from '@/constants/urls';

export function FooterLinks() {
  const links = [
    { label: 'Privacy', href: Urls.privacy_policy },
    { label: 'Terms', href: Urls.terms_of_service },
    { label: 'FAQs', href: '#faqs' },
    { label: 'Contact', href: 'mailto:support@catch.co' },
  ];

  return (
    <nav className="flex flex-wrap items-center justify-center gap-6">
      {links.map((link) => (
        <a
          key={link.label}
          href={link.href}
          target={link.href.startsWith('http') ? '_blank' : undefined}
          rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
          className="text-sm text-slate-500 hover:text-slate-700"
        >
          {link.label}
        </a>
      ))}
    </nav>
  );
}

export default FooterLinks;
